import './skeleton.css'
import MFHeaderSkeleton from './MFHeaderSkeleton'
import MFHeroSectionSkeleton from './MFHeroSectionSkeleton'

export default function MutualFundDetailPageSkeleton() {
  return (
    <div className='flex flex-col w-full'>
      <MFHeaderSkeleton />
      <InvestmentSectionSkeleton />
      <div className='border-t border-[#EBF2F2]'>
        <MFHeroSectionSkeleton />
      </div>
    </div>
  )
}

export function InvestmentSectionSkeleton() {
  return (
    <div className='flex gap-4 border-t border-[#EBF2F2] bg-white px-5 py-4'>
      <div className='h-11 w-11 shrink-0 skeleton rounded-full' />
      <div className='flex min-w-0 flex-1 flex-col gap-3'>
        <div className='flex items-start justify-between gap-3'>
          <div className='flex min-w-0 flex-1 flex-col gap-2'>
            <div className='skeleton h-4 w-48 rounded-[4px]' />
            <div className='skeleton h-3 w-32 rounded-[4px]' />
          </div>
          <div className='flex shrink-0 flex-col items-end gap-2'>
            <div className='skeleton h-6 w-24 rounded-[4px]' />
            <div className='skeleton h-3 w-20 rounded-[4px]' />
          </div>
        </div>
        <div className='skeleton h-[22px] w-36 rounded-[8px]' />
      </div>
    </div>
  )
}
